import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import EditCommissionJustificationModal from '@/components/misc/ReferralESignatureConsentPdf/components/EditCommissionJustificationModal'
import { ESIGNATURE_PDF_SECTION_STYLES } from '@/components/misc/ReferralESignatureConsentPdf/constants'
import SanitizedHtml from '@/components/misc/SanitizedHtml'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import useDialog from '@/hooks/useDialog'
import useNotyf from '@/hooks/useNotyf'
import { faPencil } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'

interface Props {
  text: string
  onEdit?: (commissionJustification: string) => void
}

const COMMISSION_JUSTIFICATION_DOM_ID = 'js-commission-justification'

const CommissionJustificationText: React.FC<Props> = ({ text, onEdit }) => {
  const notyf = useNotyf()
  const {
    isShowingDialog: isShowingEditDialog,
    showDialog: showEditDialog,
    hideDialog: hideEditDialog,
  } = useDialog()
  const isEditable = !!onEdit

  function onSave(text: string) {
    if (!onEdit) {
      throw new Error('Expected onEdit to be defined when onSave is called')
    }

    onEdit(text)

    notyf.success('Text updated')

    hideEditDialog()
  }

  return (
    <>
      <section
        id={COMMISSION_JUSTIFICATION_DOM_ID}
        className="mb-4 flex items-start gap-1"
        style={{
          paddingLeft: ESIGNATURE_PDF_SECTION_STYLES.paddingLeft,
          paddingRight: isEditable
            ? '19px'
            : ESIGNATURE_PDF_SECTION_STYLES.paddingRight,
        }}
      >
        <SanitizedHtml
          html={text}
          className={cn('grow', {
            'border-primary border': isEditable,
          })}
        />

        {isEditable && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                onClick={showEditDialog}
                variant="outline-primary"
                className="flex items-center gap-1 p-2"
              >
                <FontAwesomeIcon icon={faPencil} />
              </Button>
            </TooltipTrigger>

            <TooltipContent>Edit text</TooltipContent>
          </Tooltip>
        )}
      </section>

      {isShowingEditDialog && (
        <EditCommissionJustificationModal
          text={text}
          onSave={onSave}
          onHide={hideEditDialog}
        />
      )}
    </>
  )
}

export default CommissionJustificationText
